import { render } from "./OrderInformation.vue?vue&type=template&id=6db52ba9&scoped=true&ts=true"
import script from "./OrderInformation.vue?vue&type=script&lang=ts"
export * from "./OrderInformation.vue?vue&type=script&lang=ts"

import "./OrderInformation.vue?vue&type=style&index=0&id=6db52ba9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db52ba9"]])

export default __exports__